import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MaskLine, Wordmark } from "../components/Motion";
import { useAuth } from "../context/AuthContext";

function formatErr(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try { await login(form); nav("/account"); }
    catch (e) { setErr(formatErr(e.response?.data?.detail) || e.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-8 py-20 sm:py-28" data-testid="login-page">
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-graytx mb-4">Welcome back</p>
      <h1 className="font-display font-extrabold text-5xl sm:text-6xl uppercase leading-[0.85]">
        <MaskLine>Log In</MaskLine>
      </h1>

      <form onSubmit={submit} className="mt-10 space-y-6" data-testid="login-form">
        {[["email", "Email", "email"], ["password", "Password", "password"]].map(([k, label, type]) => (
          <div key={k}>
            <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-graytx">{label}</label>
            <input required type={type} value={form[k]} onChange={set(k)} data-testid={`login-${k}`}
              className="w-full bg-transparent border-b border-line focus:border-cream py-3 outline-none transition-colors duration-200" />
          </div>
        ))}
        {err && <p className="text-cs-red text-sm" data-testid="login-error">{err}</p>}
        <button disabled={loading} data-testid="login-btn"
          className="w-full bg-cream text-bg font-mono text-[12px] uppercase tracking-[0.2em] py-4 hover:bg-cs-yellow disabled:opacity-60 transition-colors duration-200">
          {loading ? "Signing in…" : "Log In"}
        </button>
      </form>

      <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.2em] text-graytx">
        New here? <Link to="/signup" data-testid="to-signup" className="text-cream hover:text-cs-yellow transition-colors duration-200">Create an account for 15% off</Link>
      </p>
      <div className="mt-12"><Wordmark className="text-2xl" /></div>
    </div>
  );
}
